import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { UsersIcon } from 'lucide-react'
import { Input } from '../../ui/input'
import CoachMultiSelect from '../../leevo_ui/KlassForm/CoachMultiSelect'
import SkillLevelMultiSelect from '../../leevo_ui/KlassForm/SkillLevelMultiSelect'

function CoachingSettingsSection({
  allCoaches = [],
  allSkillLevels = [],
  coaches,
  supportedSkillLevels,
  maxStudents,
  onCoachesChange,
  onSkillLevelsChange,
  onMaxStudentsChange
}) {
  const [localMaxStudents, setLocalMaxStudents] = useState(maxStudents?.toString() || '')

  useEffect(() => {
    const currentParsed = localMaxStudents === '' ? null : parseInt(localMaxStudents, 10)
    if (currentParsed !== maxStudents) {
      setLocalMaxStudents(maxStudents?.toString() || '')
    }
  }, [maxStudents])

  function handleMaxStudentsChange(e) {
    const { value } = e.target
    setLocalMaxStudents(value)
    onMaxStudentsChange(value === '' ? null : parseInt(value, 10))
  }

  return (
    <div className="bg-white border border-gray-200 rounded-lg">
      <div className="flex items-center justify-between w-full px-4 py-3">
        <div className="flex items-center space-x-2">
          <UsersIcon className="w-5 h-5 text-purple-600" />
          <h3 className="text-base font-semibold text-gray-900">Coaching Settings</h3>
        </div>
      </div>

      <div className="px-4 pb-4 space-y-4 border-t border-gray-200">
        <div className="mt-4">
          <p className="mb-4 text-sm text-gray-600">
            Pick the coaches that will be teaching this class and the skill levels they can teach.
          </p>

          <div className="space-y-4">
            <div>
              <label className="block mb-2 text-sm font-medium text-gray-900">Who will be coaching this class?</label>
              <CoachMultiSelect coaches={allCoaches || []} value={coaches} onChange={onCoachesChange} />
            </div>

            <div>
              <label className="block mb-2 text-sm font-medium text-gray-900">What levels will they be coaching?</label>
              <SkillLevelMultiSelect
                skillLevels={allSkillLevels || []}
                value={supportedSkillLevels}
                onChange={onSkillLevelsChange}
              />
            </div>

            <div>
              <label htmlFor="max_students" className="block mb-2 text-sm font-medium text-gray-900">
                How many spots are in this class?
              </label>
              <Input
                id="max_students"
                className="w-full"
                type="number"
                min={0}
                placeholder="Leave blank for unlimited spots"
                value={localMaxStudents}
                onChange={handleMaxStudentsChange}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

CoachingSettingsSection.propTypes = {
  allCoaches: PropTypes.array,
  allSkillLevels: PropTypes.array,
  coaches: PropTypes.array.isRequired,
  supportedSkillLevels: PropTypes.array.isRequired,
  maxStudents: PropTypes.number,
  onCoachesChange: PropTypes.func.isRequired,
  onSkillLevelsChange: PropTypes.func.isRequired,
  onMaxStudentsChange: PropTypes.func.isRequired
}

export default CoachingSettingsSection
